import { useEffect, useMemo, useState } from 'react';

import { currentDay, subDays } from '@actual-app/core/shared/months';
import { q } from '@actual-app/core/shared/query';

import { liveQuery } from '#queries/liveQuery';

type ActiveAccountQueryRow = {
  account: string | null;
};

export function useActiveAccountIdsWithinDays(days: number): Set<string> {
  const [activeAccountIds, setActiveAccountIds] = useState<Set<string>>(
    () => new Set(),
  );

  const query = useMemo(
    () =>
      q('transactions')
        .filter({
          date: { $gte: subDays(currentDay(), days) },
        })
        .groupBy('account')
        .select('account'),
    [days],
  );

  useEffect(() => {
    const activeAccountsLiveQuery = liveQuery<ActiveAccountQueryRow>(query, {
      onData: data => {
        setActiveAccountIds(
          new Set(
            data
              .map(row => row.account)
              .filter((accountId): accountId is string => !!accountId),
          ),
        );
      },
      onError: error => {
        console.error('Error loading active accounts:', error);
      },
    });

    return () => {
      activeAccountsLiveQuery?.unsubscribe();
    };
  }, [query]);

  return activeAccountIds;
}
